import { render, staticRenderFns } from "./IdcList.vue?vue&type=template&id=7e9f8c44&"
import script from "./IdcList.vue?vue&type=script&lang=js&"
export * from "./IdcList.vue?vue&type=script&lang=js&"
import style0 from "./IdcList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports